import React from 'react';
import { Box, Typography } from '@mui/material';
import AdminNavBarComponent from '../../components/admin/AdminNavBarComponent'; // Ajuste le chemin selon l'organisation de ton projet
import MeditationManagementComponent from '../../components/admin/MeditationManagementComponent'; // Ajuste le chemin selon l'organisation de ton projet

const AdminPrograms = () => {
  return (
    <Box>
        <AdminNavBarComponent />
    <MeditationManagementComponent />
</Box>
  );
};

export default AdminPrograms;
